import "./Register.scss";
import { NavLink, useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { registerNewUserAPI } from "../api/ClientApi";
const Register = (props) => {
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [coPassword, setCoPassword] = useState("");
  const defaultObjectCheck = {
    isValidUserName: true,
    isValidEmail: true,
    isValidPassword: true,
    isValidConfirmPassword: true,
  };
  const [objectCheckInput, setObjectCheckInput] = useState(defaultObjectCheck);
  const history = useHistory();

  const handleRegister = () => {
    let invalid = invalidInputs();
    if (invalid) {
      registerNewUserAPI({
        username: userName,
        email: email,
        password: password,
      }).then((response) => {
        let { errorCode, message } = response;
        if (errorCode === 0) {
          toast.success(message);
          history.push("/login");
        } else {
          toast.error(message);
        }
      });
    }
  };

  const invalidInputs = () => {
    setObjectCheckInput(defaultObjectCheck);
    if (!userName) {
      toast.error("Username is not empty!");
      setObjectCheckInput({ ...defaultObjectCheck, isValidUserName: false });
      return false;
    }
    if (!email) {
      toast.error("Email is not empty!");
      setObjectCheckInput({ ...defaultObjectCheck, isValidEmail: false });
      return false;
    }
    var re = /\S+@\S+\.\S+/;
    if (!re.test(email)) {
      toast.error("Email is invalid!");
      setObjectCheckInput({ ...defaultObjectCheck, isValidEmail: false });
      return false;
    }
    if (!password) {
      toast.error("Password is not empty!");
      setObjectCheckInput({ ...defaultObjectCheck, isValidPassword: false });
      return false;
    }
    if (!coPassword) {
      toast.error("Confirm password is not empty!");
      setObjectCheckInput({
        ...defaultObjectCheck,
        isValidConfirmPassword: false,
      });

      return false;
    }
    if (password !== coPassword) {
      toast.error("Password and confirm password is not the same!");
      setObjectCheckInput({
        ...defaultObjectCheck,
        isValidConfirmPassword: false,
      });
      return false;
    }
    var passRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
    if (!passRegex.test(password)) {
      toast.error(
        "Passwod has at least one number and least one special character!"
      );
      setObjectCheckInput({ ...defaultObjectCheck, isValidPassword: false });
      return false;
    }
    return true;
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <div className="auth-brand">
          <div className="auth-brand-mark">M</div>
          <span className="auth-brand-name">MDTeam Console</span>
        </div>
        <p className="auth-subtitle">Tạo tài khoản quản trị mới.</p>

        <div className="mb-3">
          <label className="form-label" htmlFor="register-username">
            Username
          </label>
          <input
            id="register-username"
            className={
              objectCheckInput.isValidUserName
                ? "form-control"
                : "form-control is-invalid"
            }
            type="text"
            placeholder="username"
            value={userName}
            onChange={(event) => setUserName(event.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="form-label" htmlFor="register-email">
            Email
          </label>
          <input
            id="register-email"
            className={
              objectCheckInput.isValidEmail
                ? "form-control"
                : "form-control is-invalid"
            }
            type="text"
            placeholder="you@example.com"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="form-label" htmlFor="register-password">
            Mật khẩu
          </label>
          <input
            id="register-password"
            className={
              objectCheckInput.isValidPassword
                ? "form-control"
                : "form-control is-invalid"
            }
            type="password"
            placeholder="••••••••"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
          <div className="form-text">
            Tối thiểu 6 ký tự, có ít nhất 1 số và 1 ký tự đặc biệt (!@#$%^&*).
          </div>
        </div>
        <div className="mb-3">
          <label className="form-label" htmlFor="register-confirm-password">
            Xác nhận mật khẩu
          </label>
          <input
            id="register-confirm-password"
            className={
              objectCheckInput.isValidConfirmPassword
                ? "form-control"
                : "form-control is-invalid"
            }
            type="password"
            placeholder="••••••••"
            value={coPassword}
            onChange={(event) => setCoPassword(event.target.value)}
          />
        </div>
        <button
          className="btn btn-primary w-100 py-2 fw-semibold"
          onClick={() => handleRegister()}
        >
          Tạo tài khoản
        </button>
        <div className="text-center mt-3">
          <NavLink to="/login" className="small text-decoration-none">
            Đã có tài khoản? Đăng nhập
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default Register;
